export default "__VITE_ASSET__2897edca__"